import React, { createContext } from 'react';

import { useOrderlineCheck, useOrderlineCheckReturnType } from '@/hooks/useOrderlineCheck';

const OrderLineContext = createContext<useOrderlineCheckReturnType | undefined>(undefined);

export function OrderLineProvider({ children }: { children: React.ReactNode }) {
  const { checkedOrderlines, onOrderlineCheck, initiateCheck } = useOrderlineCheck();

  return (
    <OrderLineContext.Provider
      value={{
        checkedOrderlines,
        onOrderlineCheck,
        initiateCheck,
      }}
    >
      {children}
    </OrderLineContext.Provider>
  );
}

export function useOrderLine() {
  const context = React.useContext(OrderLineContext);
  if (!context) {
    throw new Error('useOrderLineCheckContext must be used within a OrderLineProvider');
  }
  return context;
}
